import React from "react";
import { Phone, MessageCircle, MapPin, Clock, Instagram, Linkedin } from "lucide-react";
import { SITE } from "@/constants/testIds";

export const Footer = ({ phone, whatsapp, onCallbackClick }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-cream/80 mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-serif text-4xl md:text-5xl text-cream tracking-tight leading-[0.95]">
              ReGain
              <span className="block text-base font-sans uppercase tracking-[0.3em] text-cream/50 mt-3">
                Virtual clinic
              </span>
            </div>
            <p className="mt-6 text-cream/70 max-w-md leading-relaxed">
              A virtual clinic for the second half of life — age-related health,
              hormones, body composition and skin. Personalised. Evidence-led.
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-8">
              <a
                href={`tel:${phone}`}
                data-testid={SITE.footerCallBtn}
                className="inline-flex items-center gap-2 rounded-full bg-terracotta hover:bg-terracotta-dark text-cream px-6 py-3 text-sm font-medium transition-all duration-300 hover:-translate-y-0.5"
              >
                <Phone className="w-4 h-4" strokeWidth={1.75} /> Call {phone}
              </a>
              <a
                href={`https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}`}
                target="_blank"
                rel="noreferrer"
                data-testid={SITE.footerWhatsappBtn}
                className="inline-flex items-center gap-2 rounded-full border border-cream/30 hover:bg-cream hover:text-ink text-cream px-6 py-3 text-sm font-medium transition-all duration-300"
              >
                <MessageCircle className="w-4 h-4" strokeWidth={1.75} /> WhatsApp
              </a>
              <button
                onClick={onCallbackClick}
                data-testid={SITE.footerCallbackBtn}
                className="text-sm text-cream/80 hover:text-cream underline underline-offset-4 px-2"
              >
                Request callback
              </button>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-cream/50 mb-5">
              Reach us
            </div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-sage-light" strokeWidth={1.5} />
                <a href={`tel:${phone}`} className="hover:text-cream">{phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle className="w-4 h-4 mt-0.5 text-sage-light" strokeWidth={1.5} />
                <a
                  href={`https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-cream"
                >
                  WhatsApp {whatsapp}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-sage-light" strokeWidth={1.5} />
                <span>Mon – Sat · 10am – 7pm IST</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-sage-light" strokeWidth={1.5} />
                <span>Virtual consultations across India & abroad</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-cream/50 mb-5">
              Care pillars
            </div>
            <ul className="grid grid-cols-2 gap-y-3 text-sm">
              <li>Age-related health</li>
              <li>Hormonal balance</li>
              <li>Body composition</li>
              <li>Skin health</li>
            </ul>
            <div className="flex items-center gap-4 mt-8">
              <a href="#" aria-label="Instagram" className="text-cream/60 hover:text-cream">
                <Instagram className="w-5 h-5" strokeWidth={1.5} />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-cream/60 hover:text-cream">
                <Linkedin className="w-5 h-5" strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-cream/50">
          <p>© {year} ReGain Clinic. All rights reserved.</p>
          <p className="font-serif italic text-cream/70 tracking-[0.05em]">
            Restart · Restore · <span className="not-italic font-medium">RéGain</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
